export enum MenuItemDisplayType {
  Text = 'TEXT',
  Icon = 'ICON',
  IconText = 'ICON_TEXT',
  Button = 'BUTTON',
}

// this list comes from Admin UI. And defines list of all possible internal pages.
// https://github.com/Accedo-Products/one-admin/blob/58a8c6dea0455d2ea90e8dac047107860a9e323a/src/common/service/pages/utils/constants.js#L7
export enum InternalPageId {
  Search = 'SEARCH',
  Favorites = 'FAVORITES',
  WatchHistory = 'WATCH_HISTORY',
  Login = 'LOGIN',
  Register = 'REGISTER',
  Iap = 'IAP',
  ProgramList = 'PROGRAM_LIST',
  TermsAndConditions = 'TERMS_AND_CONDITIONS',
  Settings = 'SETTINGS',
  More = 'MORE',
  ForgotPassword = 'FORGOT_PASSWORD',
}

export enum MenuType {
  TOP = 'top-menu',
  HAMBURGER = 'hamburger',
}
